class GL {
  constructor (canvas, fs) {
    this.gl = canvas.getWebGL()
    this.gl.enable(this.gl.DEPTH_TEST)

    this.fssource = fs
    
  }

  init () {
    const v_shader = this.create_shader( this.gl, 'VERTEX_SHADER', `
      precision mediump float;
      attribute 	vec3 	position;
      uniform		float	u_time;
      uniform		float	u_zoom;
      uniform		vec2	u_resolution;
      void main(void){
        gl_Position    = vec4(position * 4.0, 1.0);
      }
    `)
    const f_shader = this.create_shader( this.gl, 'FRAGMENT_SHADER', this.fssource)
    
    this.program = this.create_program(this.gl, v_shader, f_shader)
  }

  getGL () {
    return this.gl
  }

  getProgram () {
    return this.program
  }

  create_shader ( context, type, source ) {
    const shader = context.createShader(context[type])
    context.shaderSource(shader, source)
    context.compileShader(shader)
    return context.getShaderParameter(shader, context.COMPILE_STATUS) ? shader : console.log(context.getShaderInfoLog(shader))
  }

  create_program ( gl, vs, fs ) {
    var program = gl.createProgram()
    gl.attachShader(program, vs)
    gl.attachShader(program, fs)
    gl.linkProgram(program)
    
    if(gl.getProgramParameter(program, gl.LINK_STATUS)){
      gl.useProgram(program)
      return program
    }else{
      console.log(gl.getProgramInfoLog(this.program))
    }
  }

  makeFrame () {
    var attLocation = this.gl.getAttribLocation(this.program, 'position')
    this.gl.bindBuffer(this.gl.ARRAY_BUFFER, this.gl.createBuffer())
    this.gl.bufferData(this.gl.ARRAY_BUFFER, new Float32Array([
      -1.0,   1.0,
       1.0,   1.0,
       1.0,  -1.0,
      -1.0,  -1.0
    ]), this.gl.STATIC_DRAW)
    this.gl.enableVertexAttribArray(attLocation)
    this.gl.vertexAttribPointer(attLocation, 2, this.gl.FLOAT, false, 0, 0)
    
    // ───────────────────────────────────────────────────────────
    this.gl.bindBuffer(this.gl.ELEMENT_ARRAY_BUFFER, this.gl.createBuffer())
    this.gl.bufferData(this.gl.ELEMENT_ARRAY_BUFFER, new Int16Array([
      0, 1, 2,
      2, 3, 0
    ]), this.gl.STATIC_DRAW)
  }
}

export default GL
